// 滚动触发动画组合函数
import { onMounted, onUnmounted } from 'vue'

export function useScrollAnimation(options = {}) {
  const {
    threshold = 0.15,
    rootMargin = '0px 0px -80px 0px',
    selector = '.scroll-animate',
  } = options

  let observer = null

  const initScrollAnimation = () => {
    const elements = document.querySelectorAll(selector)

    if (!elements.length) return

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 支持stagger延迟：通过data-delay属性
            const delay = entry.target.dataset.delay || 0
            setTimeout(() => {
              entry.target.classList.add('is-visible')
            }, parseInt(delay))

            // 动画只触发一次后停止观察
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold,
        rootMargin,
      }
    )

    elements.forEach((el) => observer.observe(el))
  }

  const destroyScrollAnimation = () => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
  }

  // 手动触发动画（用于首次加载时已在视口内的元素）
  const triggerVisibleElements = () => {
    const elements = document.querySelectorAll(selector)
    elements.forEach((el) => {
      const rect = el.getBoundingClientRect()
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0
      if (isVisible) {
        const delay = el.dataset.delay || 0
        setTimeout(() => {
          el.classList.add('is-visible')
        }, parseInt(delay))
      }
    })
  }

  onMounted(() => {
    // 使用requestAnimationFrame确保DOM已渲染
    requestAnimationFrame(() => {
      initScrollAnimation()
      // 短暂延迟后检查已可见的元素
      setTimeout(triggerVisibleElements, 100)
    })
  })

  onUnmounted(() => {
    destroyScrollAnimation()
  })

  return {
    initScrollAnimation,
    destroyScrollAnimation,
    triggerVisibleElements,
  }
}
